export default __webpack_public_path__ + "static/media/servicos.da0a4e89.png";